import { render, staticRenderFns } from "./ProjectCRUD.vue?vue&type=template&id=002d9a37&scoped=true&"
import script from "./ProjectCRUD.vue?vue&type=script&lang=js&"
export * from "./ProjectCRUD.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCRUD.vue?vue&type=style&index=0&id=002d9a37&lang=less&scoped=true&"
import style1 from "./ProjectCRUD.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d9a37",
  null
  
)

export default component.exports